import React from "react"
import type { Dispatch } from "react"
import type { HistoricoCaixaModel } from "../models/historicoCaixaModel"
import { HistoricoCaixaInicial } from "../models/historicoCaixaModel"
import { historicoCaixaReducer } from "./historicoCaixaReducer"
import type { HistoricoCaixaActions } from "./historicoCaixaActions"

type HistoricoCaixaContextType = {
    dados: HistoricoCaixaModel
    dispatch: Dispatch<HistoricoCaixaActions>
    erroCarregamento: string | null
    dataFiltro: string
    setDataFiltro: (data: string) => void
    recarregar: (data?: string) => void
}

export const HistoricoCaixaContext = React.createContext<HistoricoCaixaContextType>({
    dados: HistoricoCaixaInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    dataFiltro: "",
    setDataFiltro: () => undefined,
    recarregar: () => undefined,
})
